// extracted by mini-css-extract-plugin
export default {"optionName":"d3ACWYBx"};